<template>
  <main class="container">
    <UnsavedData v-if="renderWarning" v-on:leaveAndSave="leaveAndSave()" v-on:leaveWithoutSaving="leaveWithoutSaving()" v-on:closeWarning="closeWarning()"/>
    <div class="loading" v-if="loading">{{loading}}</div>
    <div class="row" v-if="submission">
      <div class="col-md-4">
        <ProgressBar :percent_complete="percent_complete"/>
      </div>
    </div>
    <div class="row" v-if="submission">
      <div class="col-md-4">
        <SideNav :categories="submission.categories" :active_category="category_id" v-on:updateActiveCategory="updateActiveCategory"/>
      </div>

      <div class="col-md-8 pl-5">
        <form @submit="updateSubmission">
          <div v-for="cat in submission.categories" v-bind:key="cat.id">

            <Category :category="cat" :renderErrorBanner="submissionUpdated" v-show="cat.id === category_id" @removeQuestionGroup="removeQuestionGroup()"/>

          </div>
          <div :class="org">
            <button class="mt-2 p-2 btn btn-primary save" type="submit" @click="buttonIdentifier('save')">Save</button>
            <button class="mt-2 p-2 btn btn-primary save" name="continue" @click="buttonIdentifier('continue')" v-if="last_category !== category_id">Save and Continue</button>
            <button class="mt-2 p-2 btn btn-primary save" type="submit" @click="buttonIdentifier('review')" v-if="last_category == category_id ">Save and Review</button>
          </div>
        </form>
      </div>
    </div>
  </main>
</template>

<script>
import axios from "../../auth.js"
import Category from "./Category.vue"
import SideNav from "./SideNav"
import UnsavedData from "./UnsavedData.vue"
import ProgressBar from "./ProgressBar.vue"

export default {
  name: 'formpage',
  components:{
    Category,
    SideNav,
    UnsavedData,
    ProgressBar
  },
  data(){
    return {
      category_id: null,
      progress: null,
      percent_complete: '0',
      submission: null,
      submission_id: null,
      submitted: null,
      button_identifier: null,
      last_category: null,
      form_complete: false,
      org: this.$route.params.organization_name,
      scholarship: this.$route.params.scholarship_name,
      subDict: null,
      unsaved: false,
      renderWarning: false,
      submissionUpdated: true,
      attemptedRoute: null,
      bypassWarning: false,
      loading: null,
      errors: []
    }
  },
  mounted(){
    this.getSubmission()
    if (this.$route.query.notify) {
      this.$toasted.success(this.$route.query.notify,
        {
          position: "bottom-right",
          duration: 10000
        })
    }
    //this.getProfile()
  },
  updated(){
    scroll(0, 0)
  },
  methods:{
    leaveWithoutSaving() {
      this.bypassWarning = true;
      this.$router.push({ path: `${this.attemptedRoute}` })
    },
    leaveAndSave() {
      this.saveSubmission(this.dictionaryBuilder(document.querySelectorAll('input,select,textarea')))
      this.bypassWarning = true;
      this.$router.push({ path: `${this.attemptedRoute}` })
    },
    getSubmission(){
      this.loading = "Loading..."

    axios.get(
        `${process.env.VUE_APP_ENDPOINT}/api/applicant/${this.org}/${this.scholarship}/`
      ).then(res => {
        if(res.data.submitted){
          this.submitted = res.data.submitted
          this.redirectSubmitted()
        }
        this.submission = res.data
        this.percent_complete = res.data.progress.percent_complete.toFixed(0)
        this.submission_id = res.data.id
        this.updateFormStatus()
        this.category_id = res.data.categories[0].id
        this.last_category = res.data.categories[res.data.categories.length - 1].id
        this.loading = false
        this.subDict = this.submissionDict(res.data.categories)
      }
      ).catch(err => {
        this.loading = ""
        this.errors.push(err)
        if( err.response && err.response.status === 404 ){
          this.createSubmission()
        }
      })
    },
    createSubmission(){
      this.loading = "Loading..."
      axios.post(
        `${process.env.VUE_APP_ENDPOINT}/api/applicant/${this.org}/${this.scholarship}/`
      ).then(res => {
        this.submission = res.data
        this.submission_id = res.data.id
        this.category_id = res.data.categories[0].id
        this.last_category = res.data.categories[res.data.categories.length - 1].id
        this.loading = false
        this.subDict = this.submissionDict(res.data.categories)
        this.loading = ""
      }
      ).catch(err => {
        this.errors.push({err});
      })
    },
    updateSubmission(event){
      event.preventDefault()
      this.saveSubmission(this.dictionaryBuilder(event.target))
    },
    updateActiveCategory(id){
      this.submissionUnsaved()
      if(this.unsaved){
        this.saveSubmission(this.dictionaryBuilder(document.querySelectorAll('input,select,textarea')))
        this.unsaved = false
      }
      this.category_id = id
    },
    saveSubmission(answer_dict){
      let answers = []
      Object.keys(answer_dict).forEach(key=>{ answers.push( {id:key, value: answer_dict[key].value })}) //<- {id:"1", value:"foo"}

      //handle multiple inputs
      answers = this.handleMultiples(answers)
      answers = this.handleEmptyEntries(answers)

      axios.put(
        `${process.env.VUE_APP_ENDPOINT}/api/applicant/${this.org}/${this.scholarship}/`,
        {
          answers: answers,
          category_id: this.category_id
        }
      ).then(res => {
        if(res.data.categories.length === 1)
          this.updateCurrentCategory(res.data.categories[0]) // Ensure the SideNavItem stays updated even when only a single category is being passed received
        else
          this.submission = res.data
        this.submission_id = this.submission.id
        this.updateFormStatus()
        this.subDict = this.submissionDict(this.submission.categories)
        this.percent_complete = res.data.progress.percent_complete.toFixed(0)
        this.submissionUpdated = true
        if(this.button_identifier == "continue"){
          this.incrementCategory(this.submission.categories)
        }
        if(this.button_identifier == "review"){
          this.$router.push({ path: 'review' })
        }
      }
      ).catch(err => {
        this.errors.push({err});
      })
    },
    updateCurrentCategory(cat){
      let new_cats = []
      for (var i = 0; i < this.submission.categories.length; i++){
        if (this.submission.categories[i].id === cat.id)
          new_cats.push(cat)
        else
          new_cats.push(this.submission.categories[i])
      }
      this.submission.categories = new_cats
    },
    updateFormStatus(){
      this.form_complete = this.submission.categories.every((category) => {
        return category.completed
      })
    },
    incrementCategory(categories){
      let current_index = categories.findIndex(category =>{
        return category.id == this.category_id
      })
      let no_errors = categories[current_index].questions.every((question) => {
        return question.answer.errors === undefined
      })
      if(no_errors){
          this.category_id = categories[current_index + 1].id
      }
    },
    buttonIdentifier(button_type){
      this.button_identifier = button_type
    },
    dictionaryBuilder(eventTarget){
      /**eventTarget can be a HTMLCollection as well */
      let all_inputs = Array.from(eventTarget)
      let dict = {} // <- {"111": {value: "abc"}}
      all_inputs.forEach(answer => {
        if (answer.id !== ""){
          if (answer.attributes.categoryId && (Number(answer.attributes.categoryId.value) === this.category_id)){

            let id = answer.id

            if(id.substring(0,4) === "file")
              answer.type = "file_upload"

            switch(answer.type) {
            case "checkbox":
              if( dict[id] === undefined ) {
                dict[id] = {value: []}
              }
              if(answer.checked){
                dict[id].value.push(answer.value)
              }else{
                dict[id].value.push("0")
              }
              break;
            case "radio":
              if(answer.checked){
                dict[id] = {value: answer.value}
              }
              break;
            case "file_upload":
              dict[id] = {value: this.getUploadUrls(answer)}
              break;
            default:
              dict[id] = {value: answer.value}
            }
          }
        }
      })
      return dict
    },
    getUploadUrls(answer){
      var urls = []
      var uploads = answer.getElementsByClassName("dz-preview")
      for(var i = 0; i < uploads.length; i++){
        urls.push(uploads[i].getElementsByClassName("dz-image")[0].getElementsByTagName("img")[0].src)
      }
      return urls
    },
    currentFormAnswers(){
      var answer_dict = this.dictionaryBuilder(document.querySelectorAll('input,select,textarea,div.dropzone'))
      let answers = []
      Object.keys(answer_dict).forEach(key=>{ answers.push( {id:key, value: answer_dict[key].value })}) //<- {id:"1", value:"foo"}
      answers = this.handleMultiples(answers)
      return answers
    },
    submissionDict(categoryArray){
      let obj = {}
      categoryArray.forEach( cat => {
        cat.questions.forEach( question => {
          if(question.repeatable && question.answer.value === "")
            obj[question.answer.id] = {value: [[]]} // Initialize answer.value[0] to be an object so we know it's a repeatable group
          else if(question.question_type === "file_upload"){
            var uploads = []
            for(var i = 0; i < question.answer.file_uploads.length; i++){
              uploads.push(question.answer.file_uploads[i].url)
            }
            obj[question.answer.id] = {value: uploads}
          }
          else
            obj[question.answer.id] = {value: question.answer.value}
        })
      })
      return obj
    },
    submissionUnsaved(){
      var answers = this.currentFormAnswers()
      for (var a in answers) {
        var answer = answers[a]
        //mutli-answer question
        if (answer.id.substring(0,4) === "file"){
          var id_only_digits = answer.id.replace(/\D/g,'') // file_upload id's look like: "file_upload3559"
          if (answer.value.length === 0 && this.subDict[id_only_digits].value.length > 0)
            this.unsaved = true
          else{
            for (var ans in answer.value) {
              if (answer.value[ans] !== this.subDict[id_only_digits].value[ans]) {
                this.unsaved = true
                break
              }
            }
          }
        }
        else if (typeof(answer.value) === "object") {
          //repeatable questions
          if (typeof(this.subDict[answer.id].value[0]) == "object") {
            for (var ans2 in answer.value) {
              if (this.subDict[answer.id].value[ans2] === undefined || (answer.value[ans2].value !== this.subDict[answer.id].value[ans2].value)) {
                this.unsaved = true
                break
              }
            }
          }
          //checkbox, radio
          else{
            for (var ans in answer.value) {
              if (answer.value[ans] !== this.subDict[answer.id].value[ans]) {
                this.unsaved = true
                break
              }
            }
          }
        } //else check for regular questions
        else if (answer.value !== this.subDict[answer.id].value) {
          this.unsaved = true
          break
        }
      }
    },
    closeWarning(){
      this.renderWarning = false
    },
    redirectSubmitted(){
      this.$toasted.error(
        "The application has already been submitted!",
        {
          theme: "outline",
          position: "bottom-right",
          duration : 10000
      })
      this.$router.push({
        name: "review",
        params: {
          organization_name: this.$route.params.organization_name,
          scholarship_name: this.$route.params.scholarship_name}
      })
    },
    findID (answers, id) {
      for (var a in answers) {
        if (answers[a].id === id) {
          return a
        }
      }
      return false
    },
    handleMultiples (answers) {
      for (var a = 0; a < answers.length; a++) {
        var answer = answers[a]
        //if last character is a letter
        if (answer.id[answer.id.length - 1].match(/[a-z]/i)) {
          //check if the entry for the question already exists
          var index = this.findID(answers, answer.id.slice(0, -1))
          if (!index) {
            answers.push({id: answer.id.slice(0, -1), value: []})
            index = answers.length - 1
            answers[index].value.push({id: answer.id.slice(0, -1), value: ""})
          }
          //check if there is already an entry for this answer instance
          var aIndex = this.findID(answers[index].value, answer.id)
          if (!aIndex) {
            answers[index].value.push(answer)
          }
          //update the value of the answer
          else {
            answers[index].value[aIndex].value = answer.value
          }
          //then remove the entry for the answer instance
          answers.splice(a, 1)
          a--
        }
      }
      return answers
    },
    handleEmptyEntries (answers) {
      var repeat_groups = {}
      let current_category = {}
      this.submission.categories.forEach( category => { if(category.id === this.category_id) { current_category = category }})
      this.submission.categories.id === this.category_id
      for (var q in current_category.questions) {
        var question = current_category.questions[q]
        if (question.repeatable) {
          if (!repeat_groups[question.repeat_group]) {
            repeat_groups[question.repeat_group] = { min: question.validation.required.minimum, questions: []}
          }
          repeat_groups[question.repeat_group].questions.push(question.answer.id)
        }
      }
      for (var group in repeat_groups) {
        var i = this.findID(answers, repeat_groups[group].questions[0].toString(10))
        if (!i) {
          for (var q1 in repeat_groups[group].questions) {
            answers.push({id: repeat_groups[group].questions[q1].toString(10), value: ""})
          }
        }
        else if (Array.isArray(answers[i].value) && ((repeat_groups[group].min + 1) < answers[i].value.length)) {
          var removeList = []
          for (var e = 1; e < answers[i].value.length; e++) {
            var filled = false
            for (var q2 in repeat_groups[group].questions) {
              var index = this.findID(answers, repeat_groups[group].questions[q2].toString(10))
              if (answers[index].value[e].value != "") {
                filled = true
              }
            }
            if (!filled) {
              removeList.push(e)
            }
          }
          //remove the extras down here
          if (0 < removeList.length) {
            for (var r = (removeList.length - 1); 0 <= r; r--) {
              if (answers[i].value.length === (repeat_groups[group].min + 1)) {
                break
              }
              var remover = removeList[r]
              for (var q3 in repeat_groups[group].questions) {
                var index2 = this.findID(answers, repeat_groups[group].questions[q3].toString(10))
                answers[index2].value.splice(remover, 1)
              }
            }
          }
        }
      }
      return answers
    },
    removeQuestionGroup(){
      this.unsaved = true
    },
    //getProfile(){
    //  if(this.$store.getters.getProfileData === null){ 
    //    axios.get(`${process.env.VUE_APP_ENDPOINT}/api/applicant/profile`)
    //    .then( res => {
    //      this.$store.commit('setProfileData', res.data.profile)
    //    })
    //    .catch( err => {
    //      this.errors.push(err)
    //    })
    //  }
    //}
  },
  beforeRouteLeave (to, from, next) {
    if(!this.submitted){
      this.submissionUnsaved()
      this.attemptedRoute = to.fullPath
      if(!this.unsaved || this.bypassWarning){
        next()
      }
      else{
        this.renderWarning = true
      }
    }else{
      next()
    }
  }
}
</script>

<style lang="scss" scoped>

.hidden {
  visibility: hidden;
}

.slide-fade-enter, .slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}

.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

</style>
